/*jshint browser:true */
import { BaseBootStrapper } from '../../org/Hibachi/client/src/basebootstrap';
import { davisdigitalfrontendmodule } from './src/davisdigital/davisdigitalfrontend.module';

//custom bootstrapper
class bootstrapper extends BaseBootStrapper {
    public myApplication:any;

    constructor() {
        var angular:any = super(davisdigitalfrontendmodule.name);
        angular.bootstrap();
    }
}

export = new bootstrapper();